import { render, staticRenderFns } from "./WorkerChannel.vue?vue&type=template&id=29f75fde&"
import script from "./WorkerChannel.vue?vue&type=script&lang=js&"
export * from "./WorkerChannel.vue?vue&type=script&lang=js&"
import style0 from "./WorkerChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports